import { NotificationItem } from '@atoms/Notifications/NotificationList';
import { NotificationApiItem } from '@atoms/Notifications/NotificationList/notificationData';
import AmplitudeHelper from '@utils/analytics';
import { AMPLITUDE_CONSTANTS } from '@utils/analytics/constants';

export const getNotificationSourceBreakdown = (
  notifications: Array<Pick<NotificationApiItem | NotificationItem, 'source'>>,
): Record<string, number> => {
  return notifications.reduce((breakdown, notification) => {
    breakdown[notification.source] = (breakdown[notification.source] || 0) + 1;

    return breakdown;
  }, {} as Record<string, number>);
};

export const getUnreadNotificationCount = (notifications: NotificationApiItem[]): number =>
  notifications.filter(notification => !notification.isRead).length;

export const logInboxListViewed = (notifications: NotificationApiItem[]): void => {
  AmplitudeHelper.logEvent(AMPLITUDE_CONSTANTS.Notifications.inboxListViewed.name, {
    unread_notifications: getUnreadNotificationCount(notifications),
    empty: notifications.length === 0,
  });
};

export const logInboxMarkAllAsReadClicked = (notifications: NotificationApiItem[]): void => {
  AmplitudeHelper.logEvent(AMPLITUDE_CONSTANTS.Notifications.inboxMarkAllAsReadClicked.name, {});
};

export const logInboxScrolled = (): void => {
  AmplitudeHelper.logEvent(AMPLITUDE_CONSTANTS.Notifications.inboxScrolled.name, {});
};

export const logInboxPermissionBannerShown = (): void => {
  AmplitudeHelper.logEvent(AMPLITUDE_CONSTANTS.Notifications.inboxPermissionBannerShown.name, {});
};

export const logInboxItemViewed = (notifications: NotificationItem[]): void => {
  AmplitudeHelper.logEvent(AMPLITUDE_CONSTANTS.Notifications.inboxItemViewed.name, {
    notification_count_viewed: notifications.length,
    notification_count_viewed_by_source: getNotificationSourceBreakdown(notifications),
  });
};
